<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <div class="vtz-no-print">
        <app-progress-bar [routeName]="routeName"></app-progress-bar>
      </div>

      @if (ballotType === 'PETITION') {
        <div>
          <h1 id="vtz-title-section-text" class="vtz-h1" i18n>
            Your petition has been successfully submitted.
          </h1>
        </div>
      } @else if(ballotType === 'POLL') {
        <h1 id="vtz-title-section-text" class="vtz-h1" i18n>
          Your poll has been successfully submitted.
        </h1>
      } @else {
        <h1 id="vtz-title-section-text" class="vtz-h1" i18n>
          Your ballot has been successfully submitted.
        </h1>
      }

      <div id="vtz-success-code-wrapper" class="vtz-success-code__wrapper">

        @if (confirmationType?.includes('ONSCREEN') && ballotType !== 'PETITION') {
          @if (emailUsed()) {
            @if(ballotType === 'POLL') {
              <div>
                <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
                The following is your Confirmation ID, which verifies that your poll has been successfully submitted. It has also been sent to the email you provided upon signup.
                </p>
              </div>
            } @else {
              <div>
                <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
                The following is your Confirmation ID, which verifies that your ballot has been successfully submitted. It has also been sent to the email you provided upon signup.
              </p>
              </div>
            }
          } @else if(ballotType === 'POLL') {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The following is your Confirmation ID, which verifies that your poll has been successfully submitted.
            </p>
          } @else {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The following is your Confirmation ID, which verifies that your ballot has been successfully submitted.
            </p>
          }
          <div id="vtz-success-code-container" class="vtz-success-code__container">
            <span id="vtz-success-code-code" class="vtz-success-code__text" 
            [attr.aria-label]="spaceOut(confirmationId)">
              {{confirmationId}}
            </span>
          </div>
        }

        @if (confirmationType?.includes('ONSCREEN') && ballotType === 'PETITION') {
          <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
            The following is your Confirmation ID, which verifies that your petition has been successfully submitted.
          <div id="vtz-success-code-container" class="vtz-success-code__container">
            <span id="vtz-success-code-code" class="vtz-success-code__text" 
            [attr.aria-label]="spaceOut(confirmationId)">
              {{confirmationId}}
            </span>
          </div>
        }

        @if(confirmationType === 'EMAIL') {
          @if(ballotType === 'PETITION') {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              Your Confirmation ID, which verifies that your petition has been successfully submitted, has been sent to the email you provided upon signup.
            </p>
          } @else if(ballotType === 'POLL') {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              Your Confirmation ID, which verifies that your poll has been successfully submitted, has been sent to the email you provided upon signup.
            </p>
          } @else {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              Your Confirmation ID, which verifies that your ballot has been successfully submitted, has been sent to the email you provided upon signup.
            </p>
          }
        }

        @if(recurrence){
          @if(ballotType === 'PETITION') {
            <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
              You may submit another petition in another {{recurrence.toLowerCase()}}.
            </p>
          } @else if(ballotType === 'POLL') {
            <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
              You may submit another poll response in another {{recurrence.toLowerCase()}}.
            </p>
          } @else {
            <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
              You may vote again in this election in another {{recurrence.toLowerCase()}}.
            </p>
          }
        }
        <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
        Once you're finished, please make sure that you end your session. Thank you for using the Voatz Web App!
        </p>
      </div>
      <div id="vtz-actions" class="vtz-actions vtz-no-print">
        <div id="vtz-button-group" class="button-group button-group--sucess">
          <button id="cancel-button" class="button-secondary vtz--hide-mobile" (click)="print()" i18n="Button label">PRINT PAGE</button>
          @if (hasMoreBallots) {
            <button id="continue-button" class="button-primary" i18n="Button label" (click)="continue()">CONTINUE</button>
          }
          <button id="submit-button" class="button-primary" i18n="Button label" (click)="exit()">END SESSION</button>
        </div>
      </div>
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>
